import { useLocation, useRouteMatch } from "react-router-dom";

export default function useRouteParams() {
  const location = useLocation();
  const match = useRouteMatch();

  // Parsing search parameters into a dictionary
  const searchParams = {};
  new URLSearchParams(location.search).forEach((value, key) => {
    searchParams[key] = value;
  });

  // Return the path parameters (from the URL), search parameters, and the search part of the location
  return {
    pathParams: match.params,
    searchParams: searchParams,
    searchPart: location.search
  };
}